import apiRequest from "../../helpers/apiRequest";

export default async (text) => {
    return await apiRequest({
        method: 'get',
        url: `content/search?search=${text}`,
    })
}
